(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-hero"] && !Shopify.designMode) return;
  try {
    
  // Hero de Fit & Flow: cambia de foto sola, se pausa con el mouse encima y se desliza con el dedo.
  // Los gestos que empiezan en el buscador o en los accesos (data-sin-deslizar) no cambian la foto.
  if (!customElements.get('ff-hero')) {
    customElements.define(
      'ff-hero',
      class FfHero extends HTMLElement {
        connectedCallback() {
          this.fotos = [...this.querySelectorAll('.ff-hero__foto')];
          this.puntos = [...this.querySelectorAll('.ff-hero__punto')];
          this.tarjetas = [...this.querySelectorAll('.ff-hero__tarjeta')];
          this.totalGrupos = Math.ceil(this.tarjetas.length / 3);
          this.grupo = 0;
          if (this.fotos.length < 2 && this.totalGrupos < 2) return;
          this.indice = 0;
          this.intervalo = Number(this.dataset.intervalo || 5.5) * 1000;
          this.puntos.forEach((punto, i) =>
            punto.addEventListener('click', () => {
              this.mostrar(i);
              this.reiniciar();
            })
          );
          this.addEventListener('mouseenter', () => this.detener());
          this.addEventListener('mouseleave', () => this.reiniciar());
          this.addEventListener(
            'touchstart',
            (e) => {
              this.toque = e.target.closest('[data-sin-deslizar]') ? null : { x: e.touches[0].clientX, y: e.touches[0].clientY };
            },
            { passive: true }
          );
          this.addEventListener('touchend', (e) => {
            if (!this.toque) return;
            const dx = e.changedTouches[0].clientX - this.toque.x;
            const dy = e.changedTouches[0].clientY - this.toque.y;
            this.toque = null;
            if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
            this.mostrar(this.indice + (dx < 0 ? 1 : -1));
            this.reiniciar();
          });
          this.reiniciar();
        }

        disconnectedCallback() {
          this.detener();
        }

        mostrar(i) {
          const n = this.fotos.length;
          this.indice = (i + n) % n;
          this.fotos.forEach((foto, k) => foto.classList.toggle('is-activa', k === this.indice));
          this.puntos.forEach((punto, k) => punto.setAttribute('aria-current', String(k === this.indice)));
        }

        detener() {
          clearInterval(this.reloj);
        }

        // Cambia el grupo de prendas flotantes (entran con una animación escalonada)
        rotarGrupo() {
          if (this.totalGrupos < 2) return;
          this.grupo = (this.grupo + 1) % this.totalGrupos;
          this.tarjetas.forEach((t) => t.classList.toggle('is-activa', Number(t.dataset.grupo) === this.grupo));
        }

        reiniciar() {
          this.detener();
          this.reloj = setInterval(() => {
            if (this.fotos.length > 1) this.mostrar(this.indice + 1);
            this.rotarGrupo();
          }, this.intervalo);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-popup"] && !Shopify.designMode) return;
  try {
    
  // Ventana del 10%: se abre una vez por visita a los N segundos. No vuelve a salir si la clienta la cerró en esta
  // visita o si ya se suscribió. Tras enviar el formulario, la página se recarga y la ventana se abre con el código.
  if (!customElements.get('ff-popup')) {
    const leer = (almacen, clave) => {
      try {
        return window[almacen].getItem(clave);
      } catch (error) {
        return null;
      }
    };
    const guardar = (almacen, clave, valor) => {
      try {
        window[almacen].setItem(clave, valor);
      } catch (error) {
        // Sin almacenamiento (modo privado): la ventana igual funciona, solo que puede volver a salir.
      }
    };
    const borrar = (almacen, clave) => {
      try {
        window[almacen].removeItem(clave);
      } catch (error) {
        // Nada que borrar.
      }
    };

    customElements.define(
      'ff-popup',
      class FfPopup extends HTMLElement {
        connectedCallback() {
          this.dialogo = this.querySelector('dialog');
          if (!this.dialogo || typeof this.dialogo.showModal !== 'function') return;

          this.querySelectorAll('[data-cerrar]').forEach((boton) => boton.addEventListener('click', () => this.cerrar()));
          this.dialogo.addEventListener('click', (evento) => {
            if (evento.target === this.dialogo) this.cerrar();
          });
          this.dialogo.addEventListener('cancel', () => guardar('sessionStorage', 'ff-popup-cerrado', '1'));
          this.querySelector('form')?.addEventListener('submit', () => guardar('sessionStorage', 'ff-popup-enviado', '1'));

          const suscritaAhora = Boolean(this.querySelector('[data-exito]'));
          if (suscritaAhora) guardar('localStorage', 'ff-popup-suscrita', '1');

          if (window.Shopify && window.Shopify.designMode) {
            this.alSeleccionar = (evento) => {
              if (evento.detail && evento.detail.sectionId === this.dataset.seccion) this.abrir();
            };
            document.addEventListener('shopify:section:select', this.alSeleccionar);
            return;
          }

          if (leer('sessionStorage', 'ff-popup-enviado')) {
            borrar('sessionStorage', 'ff-popup-enviado');
            this.abrir();
            return;
          }
          if (suscritaAhora || leer('localStorage', 'ff-popup-suscrita') || leer('sessionStorage', 'ff-popup-cerrado')) return;

          this.temporizador = setTimeout(() => this.abrir(), Number(this.dataset.espera || 3) * 1000);
        }

        disconnectedCallback() {
          clearTimeout(this.temporizador);
          if (this.alSeleccionar) document.removeEventListener('shopify:section:select', this.alSeleccionar);
        }

        abrir() {
          if (!this.dialogo.open && !document.querySelector('dialog[open]')) this.dialogo.showModal();
        }

        cerrar() {
          guardar('sessionStorage', 'ff-popup-cerrado', '1');
          this.dialogo.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-prendas"] && !Shopify.designMode) return;
  try {
    
  // Filas de prendas: las flechas mueven el carrusel una "pantalla" y se apagan al llegar a un extremo.
  if (!customElements.get('ff-prendas')) {
    customElements.define(
      'ff-prendas',
      class FfPrendas extends HTMLElement {
        connectedCallback() {
          this.pista = this.querySelector('[data-pista]');
          this.flechas = [...this.querySelectorAll('[data-direccion]')];
          if (!this.pista || this.flechas.length < 2) return;
          this.flechas.forEach((flecha) =>
            flecha.addEventListener('click', () => {
              const paso = this.pista.clientWidth * 0.9 * Number(flecha.dataset.direccion);
              this.pista.scrollBy({ left: paso, behavior: 'smooth' });
            })
          );
          this.actualizar = () => {
            const final = this.pista.scrollWidth - this.pista.clientWidth - 4;
            this.flechas[0].disabled = this.pista.scrollLeft <= 4;
            this.flechas[1].disabled = this.pista.scrollLeft >= final;
          };
          this.pista.addEventListener('scroll', this.actualizar, { passive: true });
          window.addEventListener('resize', this.actualizar);
          this.actualizar();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.actualizar);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
